export default (location: string): string => {
	switch (location) {
		case "/register":
			return "register";

		case "/":
			return "dashboard";

		default:
			return location.substring(1);
	}
};
